// extracted by mini-css-extract-plugin
export default {"cls1":"bMeHiQlRsF6Fj6x0Y3g6","cls2":"XM9BP3mJ3H5nviJ8Urqf bMeHiQlRsF6Fj6x0Y3g6","isTabletDown":"VH6oS_2Oa7l2Kvhh60rG","isPhone":"qgGv0xUGFo6NDWyyazeN"};